var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-loading-overlay"},[_c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.loading)?_c('div',{staticClass:"c-loading-overlay__overlay"}):_vm._e()]),_vm._v(" "),_vm._t("default",null,{"startLoading":_vm.startLoading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }